module.exports = __webpack_public_path__ + "img/credit-card.9cb571d7.png";